import QueryTable from "../features/schedule/QueryTable";
import PageLayout from "../ui/PageLayout";
import ButtonHelp from "../ui/ButtonHelp";
import CreateQueryForm from "../features/schedule/CreateQueryForm";

const steps = [
  {
    target: "#schedule",
    content: "Set bid alerts and save time searching for opportunities",
    title: "Schedule Bid Alerts",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: "#schedule-new",
    content: "Create a new alert by clicking 'Schedule New Alert', entering your search query, choosing the frequency, and clicking 'Create Query'",
    title: "New Alert",
    placement: "bottom-start",
    disableBeacon: true,
  },
  {
    target: "#schedule-new",
    content: "After scheduling an alert, you'll receive email updates with search results based on your profile and chosen frequency",
    title: "New Alert Created",
    placement: "centre",
    disableBeacon: true,
  },
];
export default function Schedule() {
  return (
    <div>
      <div id="schedule">
        <PageLayout
          heading="Schedule Bid Alerts"
          description="Get notified of new government contract opportunities matching your interest and based on your preference."
        >
          <div className="flex flex-col gap-8">
            <CreateQueryForm />
            <QueryTable />
          </div>
        </PageLayout>
      </div>
      <ButtonHelp steps={steps} />
    </div>
  );
}
